import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type BankAccountPurpose = "RECEIVE" | "PAY" | "BOTH";

/** A tenant bank account row from de-billing (/bil/my/accounts). */
export interface TenantBankAccount {
  id: string;
  tenantId: string;
  bankCode: string;
  bankName: string | null;
  accountNumber: string;
  accountName: string;
  shortName: string | null;
  currency: string;
  purpose: BankAccountPurpose;
  isDefault: boolean;
  isVerified: boolean;
  isActive: boolean;
  createdAt: string;
}

export interface TenantBankAccountList {
  rows: TenantBankAccount[];
  total: number;
}

export interface CreateBankAccountBody {
  bankCode: string;
  bankName?: string | null;
  accountNumber: string;
  accountName: string;
  shortName?: string | null;
  currency: string;
  purpose: BankAccountPurpose;
  isDefault?: boolean;
}

export interface UpdateBankAccountBody {
  shortName?: string | null;
  purpose?: BankAccountPurpose;
  isDefault?: boolean;
  isActive?: boolean;
}

// ── de-billing tenant accounts (the overlay this app owns) ───────────────────
export const list = () =>
  httpRequest.get("/bil/my/accounts") as Promise<TenantBankAccountList>;

export const create = (body: CreateBankAccountBody) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post("/bil/my/accounts", body as any);

export const update = (id: string, body: UpdateBankAccountBody) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.put(`/bil/my/accounts/${id}`, body as any);

// ── de-payment bank verification (REUSED as-is — same Golomt flow as ──────────
//    de-payment-admin; /pay is proxied to DEV alongside /bil). check() returns
//    { url } for Golomt (open consent) or { accountName, currency } for no-consent
//    banks. After consent, listPay() confirms the registered account + owner name.
export interface BankCheckResult {
  url?: string;
  accountNumber?: string | null;
  accountName?: string | null;
  currency?: string | null;
}

// myBusinessId: the tenant's operating businessId. Business-login users have it on
// their JWT server-side, but a tenant admin (STAFF) does not, so /my-billing must
// pass it explicitly (de-payment's check route falls back to this body value).
export const checkPay = (data: { bankName: string; number: string; myBusinessId?: string }) =>
  httpRequest.post("/pay/bank_account/check", data) as Promise<BankCheckResult>;

export interface PayAccountRow {
  id: string;
  bankName?: string;
  number?: string;
  name?: string;
  currency?: string;
}

export const listPay = (filter: { bankName: string; number: string; myBusinessId?: string }) =>
  httpRequest.post("/pay/bank_account/list", {
    offset: { page: 1, limit: 50 },
    filter
  }) as Promise<{ rows: PayAccountRow[] }>;
